import './App.css';
import { StyledEngineProvider } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import { I18nProvider } from "./Services/i18n";
import { AppContextProvider, ThemeContextProvider, UserContextProvider } from "./Services/Providers";
import Routes from "./Routes";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { persistStore } from 'redux-persist';
import store, { persistor } from './store';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { QueryCache, QueryClient, QueryClientProvider } from '@tanstack/react-query'
import GeneralLoader from './Components/UI/GeneralLoader';
// import useProducts from './Hooks/useProducts';

function App() {
  // let persistor = persistStore(store);
  const { enqueueSnackbar } = useSnackbar();
  const handleClickVariant = (data, variant) => {
    // variant could be success, error, warning, info, or default
    enqueueSnackbar(data, { variant });
  };

  // const queryClient = new QueryClient()
  const queryClient = new QueryClient({
    queryCache: new QueryCache({
      onError: (err) => {
        !err?.statusText && !!err?.response && handleClickVariant(`${err?.response?.data?.message}`, 'warning')
        !err?.statusText && !err?.response && err?.code != "ERR_CANCELED" && handleClickVariant(`${err?.message}`, 'error')
      }
    }),
  })

  // const StyledSnackbarProvider = styled(SnackbarProvider)(({ theme }) => ({
  //   '&.notistack-MuiContent-warning': {
  //     backgroundColor: '#E96102',
  //     color: "#ffffff"
  //   },
  // }));

  return (
    <Provider store={store}>
      <QueryClientProvider client={queryClient}>
        <StyledEngineProvider injectFirst>
          <UserContextProvider>
            <AppContextProvider>
              <I18nProvider>
                <ThemeContextProvider>
                  {/* <StyledSnackbarProvider
                    maxSnack={10}
                    autoHideDuration={5000}
                    dense={true}
                    disableWindowBlurListener={true}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'center',
                    }}
                  > */}
                  <PersistGate loading={<GeneralLoader />} persistor={persistor}>
                    <Router basename="/pharma">
                      <Routes />
                    </Router>
                    <ReactQueryDevtools initialIsOpen={false} />
                  </PersistGate>
                  {/* <Layout> */}
                  {/* <Outlet /> */}
                  {/* </Layout> */}
                  {/* </StyledSnackbarProvider> */}
                  {/* <Notification /> */}
                </ThemeContextProvider>
              </I18nProvider>
            </AppContextProvider>
          </UserContextProvider>
        </StyledEngineProvider>
      </QueryClientProvider>
    </Provider>
  );
}

export default App;
